(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var overlays = document.querySelectorAll('.overlay[data-scroll-blur="true"]');
  if (!overlays.length) return;

  var ticking = false;

  function update() {
    overlays.forEach(function (overlay) {
      var rect = overlay.getBoundingClientRect();
      var minBlur = parseFloat(overlay.dataset.blurMin) || 0;
      var maxBlur = parseFloat(overlay.dataset.blurMax);
      if (isNaN(maxBlur)) maxBlur = minBlur;

      var distance = rect.height || 1;
      var progress = -rect.top / distance;
      progress = Math.min(Math.max(progress, 0), 1);

      var blur = minBlur + (maxBlur - minBlur) * progress;
      overlay.style.setProperty('--overlay-blur', blur.toFixed(1) + 'px');
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
